

import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import socket from '../Components/socket'
import '../css/landing.css'
import Rightcontainer from '../Components/Rightcontainer'
import Downloadbutton from '../Components/Downloadbutton'
import Header from '../Components/Header'

export default function Landing() {
  const token = localStorage.getItem('token')
  const [userAllData, setUserAllData] = useState()
  const [siteSetting, setsiteSetting] = useState([])

  useEffect(() => {
    socket.emit('websetting', '')
  }, [])

  const fetchUser = async () => {
    const access_token = localStorage.getItem('token')
    if (!access_token) return
    const headers = { Authorization: `Bearer ${access_token}` }
    try {
      const res = await axios.get(`https://api.kakaking.in/me`, { headers })
      setUserAllData(res.data)
    } catch (e) {
      if (e.response?.status === 401) {
        localStorage.removeItem('token')
      }
    }
  }

  useEffect(() => { fetchUser() }, [])

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem('sitSetting'))
    if (items) setsiteSetting(items)
  }, [])

  return (
    <>
      <Header user={userAllData} />
      <div className='leftContainer' style={{ backgroundColor: "#edf2fa", minHeight: '100vh' }}>
        <div className='pt-5 mt-4 Orher_page_main_section'>
          <div className='landing_main_container'>
            <div className='row justify-content-center'>
              {/* Main Area */}
              <div className='col-lg-8 left-section'>
                <div className='main-area p-2'>
                  <div className="mb-3">
                    <Downloadbutton />
                  </div>
                  
                  {/* Top Message Banner */}
                  <div className="site_message_main mb-4" style={{
                    background: '#000',
                    color: '#fff',
                    borderRadius: '8px',
                    padding: '15px',
                    textAlign: 'center',
                    fontSize: '14px',
                    fontWeight: '600',
                    border: "5px solid rgb(211 168 83)", 
                    boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
                  }}>
                    {siteSetting?.homeMsg || "🙏 🙏 दोस्तों KAKAKING family हमेशा आपके साथ है कभी किसी भी भाई का विस्वास नहीं तोड़ा जाएगा 😘"}
                  </div>

                  {/* Tournaments Grid Section - Larger Cards */}
                  <div className='row px-1'> {/* Reduced padding for more width */}
                    <div className='col-6 px-2'>
                      <Link className='gameCard-container-new' to={`Homepage/ludoClassicManual`}>
                        <div className='blinking_text'>◉ LIVE</div>
                        <div className='game_boxes_premium'>
                          <img src='/images/LandingPage_img/classic.png' alt='Ludo Classic' className="img-fluid game-img-large" />
                        </div>
                      </Link>
                    </div>

                    <div className='col-6 px-2'>
                      <a
                        className='gameCard-container-new'
                        href={`https://wa.me/${siteSetting?.whatsappSupport}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div className='blinking_text'>◉ LIVE</div>
                        <div className='game_boxes_premium'>
                          <img src='/images/LandingPage_img/support.png' alt='Support' className="img-fluid game-img-large" />
                        </div>
                      </a>
                    </div>
                  </div>

                  {/* Our Tournaments Header */}
                  <div className="d-flex align-items-center my-4">
                    <div style={{ flex: 1, height: '2px', background: '#ff5252' }}></div>
                    <h5 className="mx-3 mb-0" style={{ fontWeight: '800', color: '#000', fontSize: '20px' }}>Our Tournaments</h5>
                    <div style={{ flex: 1, height: '2px', background: '#ff5252' }}></div>
                  </div>

                </div>
              </div>

              <div className='col-lg-4 d-none d-lg-block right-section'>
                <Rightcontainer />
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .blinking_text {
          animation: blinker 1.5s linear infinite;
          margin-bottom: 8px;
          color: #ff5252;
          font-weight: 800;
          font-size: 14px;
          text-align: right;
          width: 100%;
          padding-right: 5px;
        }
        @keyframes blinker {
          50% { opacity: 0; }
        }
        
        .gameCard-container-new {
            text-decoration: none;
            display: block;
            margin-bottom: 20px;
        }

        .game_boxes_premium {
          background: #fff;
          border: 5px solid #fff; 
          border-radius: 20px; 
          box-shadow: 0 12px 24px rgba(0, 0, 0, 0.18); 
          overflow: hidden;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          /* Increased height to make cards look bigger */
          aspect-ratio: 1 / 1; 
        }

        .game-img-large {
            width: 100%;
            height: 100%;
            object-fit: cover; /* Ensures image fills the large card nicely */
            transition: transform 0.3s ease;
        }

        .gameCard-container-new:hover .game_boxes_premium {
          transform: translateY(-8px);
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.25);
        }

        .gameCard-container-new:hover .game-img-large {
            transform: scale(1.05);
        }

        .left-section {
            background-color: #edf2fa;
        }
      `}</style>
    </>
  )
}